// #region Imports
import { defineComponent, reactive } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-navview-item',
    // #endregion
    // #region Properties
    props: {
        level: {
            type: Number,
            required: false,
            default: 0
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        isSelected: {
            type: Boolean,
            required: false,
            default: false
        },
        isExpanded: {
            type: Boolean,
            required: false,
            default: false
        },
        dataItem: {
            type: Object,
            required: false,
            default() {
                return reactive({
                    isExpanded: false,
                    isSelected: false,
                    caption: ''
                });
            }
        },
        moveTo: {
            type: Function,
            required: false,
        },
        hasChildren: {
            type: Function,
            required: false,
        },
    },
    // #endregion
    // #region Watch
    watch: {
        'label': function (value) {
            this.dataItem.caption = value;
        },
        'isSelected': function (value) {
            this.dataItem.isSelected = value;
        }
    },
    // #endregion
    // #region computed
    computed: {
        internal_isSelected() {
            return this.dataItem?.isSelected ?? false;
        },
        _hasChildren() {
            return ((this.hasChildren && this.dataItem) ? this.hasChildren(this.dataItem) : false);
        },
    },
    // #endregion
    // #region Methods
    methods: {
        onExpand() {
            if (this.moveTo) {
                this.moveTo(this.dataItem);
            }
        }
    }
    // #endregion
});
// #endregion
